import { i18n } from 'core/i18n';
import React from 'react';
import { LoadingDots } from 'commonsComponents/loadingDots';
import { OKButton } from 'components/commons/OKButton/OKButton';
const { formatText } = i18n

function DocumentsModalFooterPrimaryButton({
    isCurrentDocumentRead,
    areAlldocumentsAccepted,
    isCurrentDocumentAcepted,
    isSavingDocumentAcceptance,
    onConfirm,
    onContinue,
    onAcceptAndContinue,
    onContinueDisabled,
}) {
    const getContent = () => {
        if (isSavingDocumentAcceptance) return <LoadingDots inline size="large" color="dark" />;
        if (areAlldocumentsAccepted) return formatText('contractsView-dic_buttonUnderstood');
        if (isCurrentDocumentAcepted) return formatText('contractsView-dic_buttonReadNextPendingDocument');

        return formatText('contractsView-dic_buttonAcceptAndContinue');
    };

    const handleClickPrimaryButton = event => {
        if (areAlldocumentsAccepted) return onConfirm(event);
        if (isCurrentDocumentAcepted) return onContinue(event);
        onAcceptAndContinue(event);
    };

    let isDisabled = false;

    if (isCurrentDocumentRead) {
        isDisabled = isSavingDocumentAcceptance;
    } else if (!isCurrentDocumentRead && !areAlldocumentsAccepted) {
        isDisabled = true;
    }

    let handleClick;
    if (isCurrentDocumentRead || areAlldocumentsAccepted) {
        handleClick = handleClickPrimaryButton;
    } else {
        handleClick = onContinueDisabled;
    };

    return (
        <OKButton onClick={handleClick} disabled={isDisabled}>
            {getContent()}
        </OKButton>
    );
}

export default DocumentsModalFooterPrimaryButton;